import HttpStatus from 'http-status-codes';
import constants from '~/config/constants';
import { requestHandler, responseHandler, errorHandler } from '~/services/axiosHandler';

const source = process.server ? 'SERVER' : 'CLIENT';

/** @type {import('@nuxt/types').Plugin} */
export default ({ $axios, app, store }) => {
    if (store.state.csrf) {
        $axios.setHeader('x-csrf-token', store.state.csrf.token);
    }

    $axios.onRequest(config => {
        if (app.$tidalAuth.user) {
            if (!config.headers) {
                config.headers = {};
            }
            config.headers[constants.X_TIDAL_USER_ID] = String(app.$tidalAuth.user.id);
        }

        return requestHandler(config);
    });

    $axios.onResponse(response => responseHandler(response, source));

    $axios.onResponseError(error => {
        if (error.response?.status === HttpStatus.UNAUTHORIZED) {
            console.warn('UNAUTHORIZED response from an Axios request. Logging out!', error.config);
            app.$tidalAuth.logout();
            return;
        }

        errorHandler(error, source, app.$sentry);
    });
};
